// Created by Johan Schram - KOSMEO ANALYTICS - https://kosmeo-a.com on 16/05/2017.

var React = require('react');
var CreateReactClass = require('create-react-class');
var PropTypes = require('prop-types');

import AreaFinderContent from './areaFinder/area-finder-content.component';
import ErrorHandler from './common/error-handler';

import './menu.css';
import logo from '../img/logo_wtm.png'

var closeErrorHandler = null;

var WraperMap = CreateReactClass({
    propTypes : {

    },
    defaultProps : {

    },
    componentDidMount() {

    },
    getInitialState: function () {

        return {
            activeMenu: 0,
            areaFinderIconeStyle : {color : 'white'},
            spotFinderIconeStyle : {color : 'white'},
            areaFinderPosition : {top : -240 -40},
            errorHandler : false,
            errorHandlerPosition : 0,
            errorMessage : '',
            waiter :false
    };
    },
    activateAreaFinder(){

        if (this.state.activeMenu === 1 ) {
            const height = document.getElementById('areaFinderContent').clientHeight;

            this.setState({
                activeMenu: 0,
                areaFinderIconeStyle : {color : 'white'},
                spotFinderIconeStyle : {color : 'white'},
                areaFinderPosition : {top : -height}
            });
        }
        else {
            this.setState({
                activeMenu: 1,
                areaFinderIconeStyle : {color : '#2fa5ff'},
                spotFinderIconeStyle : {color : 'white'},
                areaFinderPosition : {top : '50px' }

            });
        }

    },
    updateAreaFinderPosition(){
        if (this.state.activeMenu === 0 ) {
            // console.log('updating position of areafinder')
            const height = document.getElementById('areaFinderContent').clientHeight;
            this.setState({
                activeMenu: 0,
                areaFinderIconeStyle : {color : 'white'},
                spotFinderIconeStyle : {color : 'white'},
                areaFinderPosition : {top : -height - 40}
            });
        }
    },
    handleWaiter(value){
        this.setState({
            waiter: value,
        });
    },
    errorHandler(message){

        if (this.state.activeMenu === 0){

            if (!message){
                message = ratpError()
            }

            this.setState({
                errorHandler: true,
                errorMessage : message,
                errorHandlerPosition : 50
            });
        }
        else if (this.state.activeMenu === 1){

            const height = document.getElementById('areaFinderContent').clientHeight;

            if (!message){
                message = ratpError()
            }

            this.setState({
                errorHandler: true,
                errorMessage : message,
                errorHandlerPosition : 50 + height
            });
        }

        if (closeErrorHandler !== null){
            clearTimeout(closeErrorHandler);
        }

        var closeErrorHandler = setTimeout(function(){
            this.setState({
                errorHandler: false,
                errorMessage : '',
                errorHandlerPositon : 0
            });
        }.bind(this), 3500)

    },
    render: function () {

        function renderWaiter(waiter){
            if (waiter){
                return (
                    <div className="waiter" >
                        <span className="fa fa-spinner fa-spin fa-3x fa-fw"></span>
                    </div>
                )
            }
        }

        function renderError(that){
            if (that.state.errorHandler){
                return (
                    <ErrorHandler message={that.state.errorMessage} position={that.state.errorHandlerPosition}> </ErrorHandler>
                )
            }
        }

        return (
            <div style={{position : "relative"}}>

                <div id="menu" className="ligneFlexStartCentered">
                    <div className="flexComponentNone logo" style={{padding : 10}}>
                        <img src={logo} style={{height: 40}}/>
                    </div>

                    <div className="flexComponentOne">
                    </div>

                </div>

                {renderWaiter(this.state.waiter)}

                {renderError(this)}

                <AreaFinderContent dataToPlot={this.props.dataToPlot} errorHandler={this.errorHandler} showAreaFinder={this.activateAreaFinder} updatePosition={this.updateAreaFinderPosition} handleHidePan={this.activateAreaFinder} handleWaiter={this.handleWaiter} position={this.state.areaFinderPosition} />


            </div>
        )
    }
});

module.exports = WraperMap;

function ratpError (){

    var errorLisr = [
        "En raison d'un malaise voyageur, le traffic WTM est perturbé.",
        "En raison d'une panne de signalisation, le traffic WTM est perturbé.",
        "En raison d'une panne de caténaire, le traffic WTM est perturbé.",
        "En raison d'un pigeon sur les voies, le traffic WTM est perturbé.",
        "En raison de voyageur sur les voies, le traffic WTM est perturbé.",
        "En raison des fortes chaleurs, le traffic WTM est perturbé.",
        "En raison d'une grève, le traffic WTM est perturbé.",
        "Sans raison apparente, le traffic WTM est perturbé."
    ];

    // On renvoie un entier aléatoire entre une valeur min (incluse) et une valeur max (exclue).
    function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min)) + min;
    }

    return errorLisr[getRandomInt(0, errorLisr.length)]

}




{/*<div className="spotFinder flexComponentOne" style={this.state.spotFinderIconeStyle}>*/}
    {/*<span className="fa fa-glass fa-2x"></span>*/}
{/*</div>*/}

{/*<div className="spotFinder flexComponentOne" style={this.state.areaFinderIconeStyle}>*/}
    {/*<span className="fa fa-users fa-2x" onClick={this.activateAreaFinder}></span>*/}
{/*</div>*/}


// WEBPACK FOOTER //
// ./src/components/menu.js